// Kolor rezerwacji wynika z jej numeru, więc ta sama rezerwacja ma ten sam kolor w kalendarzu
// rezerwacji (pages/calendar) i w kalendarzu sprzętu (pages/EquipmentCalendar.js). Dawniej
// paleta siedziała wyłącznie w kalendarzu rezerwacji, a kalendarz sprzętu malował wszystko
// jednym czerwonym, przez co dwie stykające się rezerwacje zlewały się w jeden pasek.
export const RESERVATION_COLORS = [
  '#2563eb', // niebieski
  '#059669', // zielony
  '#7c3aed', // fioletowy
  '#d97706', // pomarańczowy
  '#be185d', // różowy
  '#0891b2', // cyjan
  '#dc2626', // czerwony
  '#0d9488', // turkus
  '#9333ea', // fiolet
  '#ea580c', // pomarańcz
];

export function reservationColor(reservationId) {
  const n = Math.abs(Math.trunc(Number(reservationId) || 0));
  return RESERVATION_COLORS[n % RESERVATION_COLORS.length];
}
